import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from '@/redux/utils'

export interface LLM {
  id: number
  name: string
}

export const llmSlice = createApi({
  reducerPath: 'llm',
  baseQuery,
  endpoints: builder => ({
    readAllLLMs: builder.query<LLM[], void>({
      query: () => '/llm/all',
    }),
  }),
})

export const {
  useReadAllLLMsQuery,
} = llmSlice
